import { render, staticRenderFns } from "./SignatureTemplateFiviumDigital.vue?vue&type=template&id=5e591b88&scoped=true"
import script from "./SignatureTemplateFiviumDigital.vue?vue&type=script&lang=js"
export * from "./SignatureTemplateFiviumDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e591b88",
  null
  
)

export default component.exports